export interface tutorial {
    tema: string,
    titulo: string,
    tituloAlternativo: string,
    caminho: string,
    caminhoAlternativo: string,
    passos: string,
    passosAlternativo: string,
    explicacao: string,
    explicacaoAlternativo: string
}

export const listaTutorial: tutorial[] = [
    {
        tema: 'contaBancaria',
        titulo: 'Conta Bancária',
        tituloAlternativo: '',
        caminho: '/conta-bancaria/adicionar',
        caminhoAlternativo: '',
        passos: 'Banco, agência, tipo de banco...',
        passosAlternativo: '',
        explicacao: 'Cadastrar conta bancária para poder importar extrato mensalmente (a partir do dia 1º é possível importar extrato do mês anterior)',
        explicacaoAlternativo: '',
    },
    {
        tema: 'cliente',
        titulo: 'Cliente',
        tituloAlternativo: '',
        caminho: '/clientes/adicionar',
        caminhoAlternativo: '',
        passos: 'Nome, CNPJ, email, telefone, endereço...',
        passosAlternativo: '',
        explicacao: '',
        explicacaoAlternativo: '',
    },
    {
        tema: 'importacaoExtrato',
        titulo: 'Importação extrato bancário',
        tituloAlternativo: 'Lançamento manual de caixa',
        caminho: '/importacao-extrato-bancario',
        caminhoAlternativo: '/listar-lancamento-caixa',
        passos: 'Selecione a conta bancária, período do extrato, .ofx ou planilha referente ao extrato',
        passosAlternativo: 'Para transações financeiras que não transitem pelo banco (ex: em dinheiro)',
        explicacao: 'Importar extratos bancários, devendo classificá-lo da melhor maneira, de forma que sejam melhor identificadas as transações bancárias',
        explicacaoAlternativo: 'Caso ocorram transações financeiras em dinheiro (que não transitem pelo banco), o usuário deverá fazer lançamentos manuais de caixa',
    },
    {
        tema: 'planoDeContas',
        titulo: 'Plano de contas',
        tituloAlternativo: '',
        caminho: '/plano-de-contas',
        caminhoAlternativo: '',
        passos: 'Atualizar plano de contas, informar saldos anteriores, adicionar contas contábeis',
        passosAlternativo: '',
        explicacao: 'Atualizar plano de contas informando saldos anteriores e adicionando contas contábeis, caso necessário',
        explicacaoAlternativo: '',
    },
    {
        tema: 'socio',
        titulo: 'Sócios',
        tituloAlternativo: '',
        caminho: '/socios',
        caminhoAlternativo: '',
        passos: 'Cadastrar sócios',
        passosAlternativo: '',
        explicacao: '',
        explicacaoAlternativo: '',
    },
    {
        tema: 'notaFiscal',
        titulo: 'Emissão/cancelamento nota fiscal',
        tituloAlternativo: '',
        caminho: '/emissao-nfse',
        caminhoAlternativo: '/importar-nfse-emitidas',
        passos: 'Emitir nota fiscal',
        passosAlternativo: ', caso emitida fora do sistema, importar pela planilha disponibilizada',
        explicacao: 'Emitir/cancelar notas fiscais pelo sistema. caso emita notas fiscais por outros sistema, deverá importar estas notas através da planilha disponibilizada no AdvVenture',
        explicacaoAlternativo: '',
    },
    {
        tema: 'declaracaoFiscal',
        titulo: 'Declarações fiscais',
        tituloAlternativo: '',
        caminho: '/listar-declaracoes-fiscais',
        caminhoAlternativo: '',
        passos: 'Verificar declarações enviadas pelo AdvVenture mensalmente',
        passosAlternativo: '',
        explicacao: 'Importar extratos bancários, devendo classificá-lo da melhor maneira, de forma que sejam melhor identificadas as transações bancárias',
        explicacaoAlternativo: '',
    },
    {
        tema: 'descricaoPadrao',
        titulo: 'Descrição padrão',
        tituloAlternativo: '',
        caminho: '/descricao-padrao',
        caminhoAlternativo: '',
        passos: 'Adicionar, editar ou excluir descrição padrão',
        passosAlternativo: '',
        explicacao: 'Adicionar, editar ou excluir descrição padrão',
        explicacaoAlternativo: '',
    },
    {
        tema: 'tributo',
        titulo: 'Tributo',
        tituloAlternativo: '',
        caminho: '',
        caminhoAlternativo: '',
        passos: 'Consultar guia de pagamentos de tributos geradas e realizar pagamento',
        passosAlternativo: '',
        explicacao: 'Consultar as guias de pagamento de tributo geradas pelo Advventure (Menu Tributos) e pagá-las pelo seu banco, sinalizando no AdvVenture o seu pagamento',
        explicacaoAlternativo: '',
    },

]